import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminRoute from "./components/AdminRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import CartPage from "./components/CartPage";
import CategoryPage from "./components/CategoryPage";
import ForgotPassword from "./components/ForgotPassword";
import Login from "./components/Login";
import ProductDetail from "./components/ProductDetail";
import Signup from "./components/Signup";
import { AuthProvider } from "./contexts/AuthContext";
import MobileCoverLandingPage from "./MobileCoverLandingPage";
import AdminPanel from "./pages/admin/AdminPanel";
import OrderManagement from "./pages/admin/OrderManagement";
import ProductListPage from "./pages/admin/ProductListPage";
import theme from "./theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<MobileCoverLandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/category/:categoryName" element={<CategoryPage />} />
          {/* Moved ForgotPassword back to public routes for consistency */}
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected User Routes */}
          <Route
            path="/product/:productId"
            element={
              <AuthenticatedRoute>
                <ProductDetail />
              </AuthenticatedRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <AuthenticatedRoute>
                <CartPage />
              </AuthenticatedRoute>
            }
          />

          {/* Protected Admin Routes */}
          <Route
            path="/admin/*"
            element={
              <AdminRoute>
                {/* Stable wrapper to prevent unnecessary unmounting */}
                <div>
                  <Routes>
                    <Route path="/" element={<AdminPanel />}>
                      <Route path="products" element={<ProductListPage />} />
                      <Route path="orders" element={<OrderManagement />} />
                    </Route>
                  </Routes>
                </div>
              </AdminRoute>
            }
          />

          {/* Fallback Route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;